const messages = {
  "ui.emailRecipientList.waringText.tooltip.duplicate": "Duplicate email detected",
  "ui.emailRecipientList.waringText.tooltip.duplicate.description":
    "This email already exists in the selection. Remove to avoid sending the same email twice.",
  "ui.emailRecipientList.waringText.tooltip.missingFields": "Missing dynamic variable",
  "ui.emailRecipientList.waringText.tooltip.missingFields.description":
    "This email doesn’t have a value for at least one dynamic variable that was used.",
  "ui.emailRecipientList.waringText.tooltip.ok": "Remove",
  "ui.emailRecipientList.waringText.tooltip.title":
    "Issues were detected with this recipient's email:",
} as const;

export default messages;
